
export default {
  name: 'IndexLayout',
  
  created() {
  },
  data() {
    return {
      drawer: false,
      iFrameCode: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-M63GR3D4" height="0" width="0" style="display:none;visibility:hidden"/></iframe>'
    }
  },
  watch: {
  },
  methods: {
    changeDrawer(value) {
      this.drawer = value
    },

    logout() {
      this.$auth.logout(/* .... */)
    },
  },
}
